import React, { PureComponent } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Button } from '@material-ui/core';
import { Query } from 'react-apollo';
import { Link, withRouter } from "react-router-dom";
import { GetAllAssessments } from '../../../queries/assessment';
import { toggleTourOff } from '../../../redux/actions/toggleTourActions';
import tourEnd from '../../../img/tourEnd.png'
import { withStyles } from '@material-ui/core/styles';
import '../../../scss/component/tour.scss';
import { connect } from 'react-redux';


/*export default function EndTour({modal}) {
  const history = useHistory();
  const StyledButton = withStyles({
    root: {
      background: '#2d9aa6',
      '&:hover': {
        background: '#2d9aa6'
      },
      borderRadius: 3,
      border: 0,
      color: '#FFFFFF',
      height: '40px',
      width: '260px',
      boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    },
    label: {
      textTransform: 'none',
    },
  })(Button);

  // const toggle = () => setModal(!modal);

  return (
    <div>
      <Query
        query={GetAllAssessments()}
        fetchPolicy={'network-only'}
        // onError={(e) => {
        //   if (e.networkError) {
        //     if (e.networkError['statusCode'] === 401) {
        //       this.signoutUser()
        //     }
        //   } else {
        //     console.log(e.message)
        //     this.signoutUser()
        //   }
        // }}
        onCompleted={(data) => {
        }}
      >

        {(data) => {

          if (data) {
            let _data = Object.assign({}, data.data)
            let sendToAssessment = true;

            Object.keys(_data).forEach(
              (prop) => {
                if (_data[prop] !== null) {
                  sendToAssessment = false;
                }
              }
            );

            return (
              <Modal id="endModal" isOpen={modal}>
                <ModalHeader className="pretty">
                  <img id="successImage" src={tourEnd} alt="" />
                </ModalHeader>
                <ModalBody id="body">
                  <div id="nice">Nice, now you're a Posture Guru!</div>
                  <div id="knock">Let's knock those compliance goals out!</div>
                </ModalBody>
                <ModalFooter className="pretty">
                  {sendToAssessment ? (
                    <StyledButton
                      onClick={()=>{toggleTourOff(); history.replace('/app/assessment')}}
                    >
                      <Link className="text" to=''>
                        Complete Your Assessment
                      </Link>
                    </StyledButton> 
                  ) : (
                    <StyledButton
                      onClick={()=>{toggleTourOff(); history.replace('/app/playbook/hipaa')}}
                    >
                      <Link className="text" to=''>
                        Start with your Playbook
                      </Link>
                    </StyledButton>
                  )}
                </ModalFooter>
              </Modal>
            )
          }
          //   } catch (e) {
          //     if (e.networkError) {
          //       if (e.networkError['statusCode'] === 401) {
          //         this.signoutUser()
          //       }
          //     } else {
          //       console.log(e.message)
          //       this.signoutUser()
          //     }
          //   }
          // })().catch(error => {
          //   console.log(error)
          // })
        }}
      </Query>
    </div>
  );
}*/

const StyledButton = withStyles({
  root: {
    background: '#2d9aa6',
    '&:hover': {
      background: '#2d9aa6'
    },
    borderRadius: 3,
    border: 0,
    color: '#FFFFFF',
    height: '40px',
    width: '260px',
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  },
  label: {
    textTransform: 'none',
  },
})(Button);

class EndTour extends PureComponent {

  /*signoutUser () {
    this.props.signout();
    this.props.history.push('/');
  }*/

  render(){
    const { modal } = this.props;
    return (
      <div>
      <Query
        query={GetAllAssessments()}
        fetchPolicy={'network-only'}
         /*onError={(e) => {
           if (e.networkError) {
             if (e.networkError['statusCode'] === 401) {
               this.signoutUser()
             }
           } else {
             console.log(e.message)
             this.signoutUser()
           }
         }}*/
        onCompleted={(data) => {
        }}
      >
        {(data) => {

          if (data) {
            let _data = Object.assign({}, data.data)
            let sendToAssessment = true;

            Object.keys(_data).forEach(
              (prop) => {
                if (_data[prop] !== null) {
                  sendToAssessment = false;
                }
              }
            );

            return (
              <Modal id="endModal" isOpen={modal}>
                <ModalHeader className="pretty">
                  <img id="successImage" src={tourEnd} alt="" />
                </ModalHeader>
                <ModalBody id="body">
                  <div id="nice">Nice, now you're a Posture Guru!</div>
                  <div id="knock">Let's knock those compliance goals out!</div>
                </ModalBody>
                <ModalFooter className="pretty">
                  {sendToAssessment ? (
                    <StyledButton
                      onClick={()=>{this.props.dispatch(toggleTourOff()); this.props.history.replace('/app/assessment')}}
                    >
                      <Link className="text" to=''>
                        Complete Your Assessment
                      </Link>
                    </StyledButton> 
                  ) : (
                    <StyledButton
                      onClick={()=>{this.props.dispatch(toggleTourOff()); this.props.history.replace('/app/playbook/hipaa')}}
                    >
                      <Link className="text" to=''>
                        Start with your Playbook
                      </Link>
                    </StyledButton>
                  )}
                </ModalFooter>
              </Modal>
            )
          }
        }}
      </Query>
    </div>
    )
  }
}

function mapStateToProps(state) {
  return {
      user: state.auth.user,
      settings: state.auth.settings,
      toggleTour: state.toggleTour
  }
}

export default connect((mapStateToProps))(withRouter(EndTour))


// WEBPACK FOOTER //
// ./src/components/tour/training/EndTour.js